
import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';

class CampaignsEdit extends React.Component
{
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
        this.renderPromosOptions = this.renderPromosOptions.bind(this);
        this.renderAddedPromos = this.renderAddedPromos.bind(this);
        this.addPromo = this.addPromo.bind(this);

        this.state = {
            promos: [],
            added_promos: [],
            campaign: {},
            request: {},
            successRegister: false
        };
    }

    componentWillMount()
    {
        let self = this;
        let id = self.props.id_campaign;

        axios.get('/api/campaigns/details/' + project + '/' + id)
            .then(response => {
                self.setState({
                    campaign: response.data.campaign,
                    added_promos: response.data.added_promos,
                    promos: response.data.promos
                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "No ha sido posible recuperar los detalles de esta campaña.",
                    icon: "warning",
                });
            });
    }

    componentDidMount()
    {
        let self = this;
    }

    handleChange({target})
    {
        let self = this;

        let campaign = self.state.campaign;
        campaign[target.id] = target.value;

        self.setState({
            campaign: campaign
        });
    }

    save()
    {
        let self = this;
        let campaign = self.state.campaign;

        campaign['added_promos'] = self.state.added_promos;

        if (!campaign.description) {
            swal({
                title: "¡Oh no!",
                text: "Por favor, completa los campos antes de proceder.",
                icon: "warning",
            });
        } else {
            if (campaign.added_promos.length === 0) {
                swal({
                    title: "¡Oh no!",
                    text: "No has agregado promociones a la campaña.",
                    icon: "warning",
                });
            } else {

                axios.post('/api/campaigns/update', campaign)
                    .then(response => {

                        let campaignResponse = response.data;

                        $('#campaignRegisterButton').remove();
                        $("#campaignsForm :input").attr("disabled", true);

                        self.setState({
                            successRegister: true
                        });

                        swal({
                            title: "¡Campaña actualizada!",
                            icon: "success",
                        });
                    })
                    .catch(error => {
                        swal({
                            title: "¡Oh no!",
                            text: "Ha ocurrido un error al procesar tu solicitud.",
                            icon: "warning",
                        });
                    });
            }
        }
    }

    addPromo()
    {
        let self = this;
        let inputPromo = $('#promo option:selected').text();

        let promos = self.state.promos;
        let added_promos = self.state.added_promos;

        let obj = $.grep(added_promos, function(obj){return obj.description === inputPromo;})[0];

        if (typeof obj === 'undefined') {
            let obj = $.grep(promos, function(obj){return obj.description === inputPromo;})[0];
            let index = promos.map(function(o) { return o.description; }).indexOf(inputPromo);

            added_promos.push(obj);
            promos.splice(index, 1);

            self.setState({
                promos: promos,
                added_promos: added_promos
            });
        } else {
            swal({
                title: "¡Oh no!",
                text: "Ya se ha agregado esta promoción.",
                icon: "warning",
            });
        }
    }

    removePromo(item)
    {
        let self = this;
        let promos = self.state.promos;
        let added_promos = self.state.added_promos;

        let index = added_promos.map(function(o) { return o.description; }).indexOf(item.description);
        promos.push(item);
        added_promos.splice(index, 1);

        self.setState({
            promos: promos,
            added_promos: added_promos
        });
    }

    renderPromosOptions(item)
    {
        return(
            <option key={item.id} value={item.id}>
                {item.description}
            </option>
        );
    }

    renderAddedPromos(item)
    {
        return(
            <tr key={item.id}>
                <td>
                    {item.description}
                </td>
                <td>
                    <button className="btn btn-danger" onClick={this.removePromo.bind(this, item)}>
                        <i className="fa fa-trash-o"></i> Eliminar
                    </button>
                </td>
            </tr>
        );
    }


    render()
    {
        let self = this;

        return (

            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                <div className={"panel-header"}>
                                    <div className={"row"}>
                                        <div className="col-md-4 col-md-offset-4" style={{ paddingTop: "25px", paddingBottom: "25px" }}>
                                            <div className="col-md-8 col-md-offset-2">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="panel-body">
                                    <div className="col-md-12">
                                        <h4 className="m-t-0 header-title"><b>Editar una Campaña</b></h4>
                                        <br/>
                                        <form role="form" id="campaignsForm">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="description">Descripción</label>
                                                        <input typeof="text" className="form-control" id="description"
                                                               value={this.state.campaign.description}
                                                               onChange={this.handleChange} />
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="notes">Notas</label>
                                                        <textarea typeof="number" className="form-control" id="notes"
                                                                  value={this.state.campaign.notes}
                                                                  onChange={this.handleChange} />
                                                    </div>

                                                    <button type="button" className="btn btn-purple waves-effect waves-light"
                                                            id="campaignRegisterButton" onClick={this.save}
                                                            disabled={!self.state.campaign.description}>
                                                        <i className="fa fa-save"></i> Guardar
                                                    </button>

                                                    {
                                                        this.state.successRegister &&
                                                        <div>
                                                            <a href="/campaigns" className="btn btn-success waves-effect waves-light">
                                                                <i className="fa fa-arrow-circle-o-left"></i> Regresar
                                                            </a>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="col-md-4 col-md-offset-1" style={{ marginTop: "-22px" }}>
                                                    <table className="table">
                                                        <thead>
                                                        <tr>
                                                            <th>Promoción</th>
                                                            <th></th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td>
                                                                <select className="form-control" id="promo" onChange={this.handleChange}>
                                                                    <option value={""}>Selecciona una promoción</option>
                                                                    {this.state.promos.map(this.renderPromosOptions)}
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <button type="button" className="btn btn-info" onClick={this.addPromo}>
                                                                    <i className="fa fa-plus"></i> Agregar
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        {this.state.added_promos.map(this.renderAddedPromos)}
                                                        </tbody>
                                                    </table>

                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CampaignsEdit;

if (document.getElementById('campaigns_edit-component')) {
    ReactDOM.render(<CampaignsEdit id_campaign={id_campaign}/>, document.getElementById('campaigns_edit-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/CampaignsEdit.jsx